import { Modal } from "antd";
import React from "react";

const UniversalModal = ({
  open,
  onClose,
  title,
  message,
  footerButtonLabel = "Close",
  onFooterButtonClick,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      className="universal-modal"
      width={660}
    >
      <div className="universal-modal-content">
        {title && (
          <h4 className="universal-modal-title" style={{ color: "white" }}>
            {title}
          </h4>
        )}
        {message && <p className="universal-modal-message">{message}</p>}
        <div style={{ textAlign: "center", marginTop: "24px" }}>
          <button
            className="back-home-btn"
            onClick={onFooterButtonClick || onClose}
          >
            {footerButtonLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default UniversalModal;
